import { render, staticRenderFns } from "./ErrorSnackbar.vue?vue&type=template&id=53fa7d98&scoped=true&"
import script from "./ErrorSnackbar.vue?vue&type=script&lang=js&"
export * from "./ErrorSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./ErrorSnackbar.vue?vue&type=style&index=0&id=53fa7d98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa7d98",
  null
  
)

export default component.exports